import { useState, type LegacyRef } from 'react';
import PureModal from 'react-pure-modal';
import type { SelectionEntries } from '../utils/dropdownMultiSelector/DropdownMultiSelector';
import DropdownMultiSelector from '../utils/dropdownMultiSelector/DropdownMultiSelector';

interface ActionListProps {
  open: boolean;
  onCancel: () => void;
  options: SelectionEntries[];
  onOptionClick: (valueIds: number[]) => void;
  defaultValues: number[];
}

function EditReportModels(
  { defaultValues, options, onOptionClick, onCancel, open }: ActionListProps,
  _ref: LegacyRef<HTMLDivElement>
) {
  const [selectedValues, setSelectedValues] = useState<number[]>(defaultValues);

  const setSelection = (values: number[]) => {
    const newSelectedValues = [...values];
    setSelectedValues(newSelectedValues);
  };

  return (
    <PureModal
      header="Modifier les associations"
      className="pure-modal-management"
      isOpen={open}
      closeButton={<span className="icon" uk-icon="close"></span>}
      closeButtonPosition="header"
      onClose={onCancel}
    >
      <form className={`form `}>
        <DropdownMultiSelector
          onSelect={(value) => setSelection(value)}
          values={options as SelectionEntries[]}
          label={'Modèles associés'}
          defaultValues={defaultValues}
        />
        <button
          type="submit"
          className="uk-button uk-button-primary"
          onClick={() => onOptionClick(selectedValues)}
          disabled={
            selectedValues.length === defaultValues.length &&
            selectedValues.every((vs) => defaultValues.includes(vs))
          }
        >
          Enregistrer
        </button>
      </form>
    </PureModal>
  );
}

export default EditReportModels;
